import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextInput from '../../components/TextInput';

class FloridaSalesTax extends Component {
  render() {
    const { floridaSalesTax } = this.props;
    return (
      <div className="Row Title-feeRow">

        <TextInput
          id="Sales"
          value={floridaSalesTax || '0.00'}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <b>Florida Sales Tax</b>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    floridaSalesTax: state.salestaxes.floridaSalesTax,
  };
};

export default connect(mapStateToProps)(FloridaSalesTax);
